import axios from "axios";

export default function fetchProductFormData({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ productFormDataUrl }) =>
    axios
      .get(productFormDataUrl, {
        cancelToken: source.token,
      })
      .then((response) => {
        return response.data;
      });
}
